import { docsUrl } from './config';

export const FETCH_INTERVAL = 10000;
export const FOCUS_CHANGE_DEBOUNCE = 100;
export const MESSAGE_MAX_LENGTH = 280;
export const SIDEBAR_WIDTH = 400;

export const docsLinks = {
  webhooks: `${docsUrl}/guides/extensions/#webhook-extension`,
  inbox: `${docsUrl}/api/inbox/`,
  export: `${docsUrl}/guides/import-and-export/#export`,
  schema: `${docsUrl}/guides/queue-schema/#identifiers`,
  validatingPayloads: `${docsUrl}/guides/extensions/#validating-payloads-from-rossum`,
  webhookEvents: `${docsUrl}/guides/extensions/#webhook-events`,
  codeEditorApiDocs: `${docsUrl}/guides/extensions/#serverless-function-extension`,
  sso: `${docsUrl}/guides/overview/#single-sign-on-sso`,
  webhookVsConnector: `${docsUrl}/guides/extensions/#webhook-vs-connector`,
  hookConfiguration: `${docsUrl}/api/hook/`,
  hookSecrets: `${docsUrl}/api/hook/`,
  tokenOwner: `${docsUrl}/guides/extensions/#limitations`,
  userRole: `${docsUrl}/api/user-role/`,
  runtimeDeprecations: `${docsUrl}/guides/extensions/#runtime-deprecations`,
  rirFieldName: `${docsUrl}/guides/queue-schema/#identifiers`,
  txscript: `${docsUrl}/guides/rossum-transaction-scripts/`,
};

export const DEVELOPER_HUB_LINK = 'https://developers.rossum.ai';
export const HELP_CENTER_LINK = 'https://knowledge-base.rossum.ai';
export const CONTACT_FORM_LINK = 'https://rossum.ai/contact';
export const DOC_SPLIT_LINK = `${HELP_CENTER_LINK}/docs/splitting-documents-in-rossum`;
export const AUTOMATION_DATA_CAPTURE_LINK = `${HELP_CENTER_LINK}/docs/guide-to-automation-process-in-rossum`;
export const CONFIRMED_STATE_LINK = `${HELP_CENTER_LINK}/docs/exporting-captured-data#how-to-export-data-from-the-confirmed-tab`;
export const ENUM_EDITOR_LINK = `${HELP_CENTER_LINK}/docs/fill-in-a-dropdown-field-from-a-spreadsheet`;
export const WEBHOOKS_LINK = `${HELP_CENTER_LINK}/docs/rossum-webhook`;
export const FUNCTIONS_LINK = `${HELP_CENTER_LINK}/docs/customize-rossum-logic-with-a-serverless-function`;
export const KEYBOARD_SHORTCUTS_LINK = `${HELP_CENTER_LINK}/docs/keyboard-shortcuts`;
export const CONFIDENCE_THRESHOLDS_LINK = `${DEVELOPER_HUB_LINK}/docs/using-ai-confidence-thresholds-for-automation-in-rossum`;
export const HOWTO_CREATE_CUSTOM_FIELD_LINK = `${HELP_CENTER_LINK}/docs/how-to-add-a-field-in-json-code-editor`;
export const HOWTO_CREATE_CUSTOMIZE_TABLE_LINK = `${HELP_CENTER_LINK}/docs/capturing-custom-table-data-in-rossum`;
export const DEVELOPER_ARTICLE_LINK = `${DEVELOPER_HUB_LINK}/docs/how-to-use-serverless-functions`;
export const HOWTO_ACCESS_PUBLIC_API_FROM_FUNCTION = `${DEVELOPER_HUB_LINK}/docs/how-to-access-public-api-on-internet-with-rossum-function`;
export const HOWTO_TEST_FUNCTION = `${DEVELOPER_HUB_LINK}/docs/how-to-test-serverless-functions`;
export const AUTOMATION_PROCESS = `${HELP_CENTER_LINK}/docs/guide-to-automation-process-in-rossum`;
export const FIELDS_VALUE_NOT_FOUND = `${DEVELOPER_HUB_LINK}/docs/automation-rules-overview`;
export const EMAIL_HELP_LINK = `${DEVELOPER_HUB_LINK}/docs/set-up-email-forwarding-to-your-rossum-account`;
export const FIRST_EXTENSION_LINK = `${DEVELOPER_HUB_LINK}/docs/first-extension-steps`;
export const AUTOMATION_BUILT_IN_CHECKS = `${DEVELOPER_HUB_LINK}/docs/automation-built-in-checks`;
export const EXTRACTED_FIELD_TYPES_LINK = `${docsUrl}/api/engine-field/#generic_ap-default`;
export const QUICK_START_GUIDE = `${HELP_CENTER_LINK}/docs/getting-started-with-rossum`;
export const ROSSUM_EMAIL_INBOX = `${HELP_CENTER_LINK}/docs/email-inbox-in-rossum`;
export const ROSSUM_VIDEOS_LINK = 'https://rossum.ai/resources/demo-hub';
export const CLI_HELP_LINK = `${HELP_CENTER_LINK}/docs/aurora-for-complex-tables`;
export const RULES_HOW_TO_LINK = `${HELP_CENTER_LINK}/docs/rules-in-rossum`;

export const BUILTIN_CHECKS_LINK = `${HELP_CENTER_LINK}/docs/built-in-checks-overview`;
export const HISTORY_CHECKS_LINK = `${HELP_CENTER_LINK}/docs/history-based-data-checks`;
export const CUSTOM_CHECKS_LINK = `${HELP_CENTER_LINK}/docs/implementing-custom-rules-for-automation-in-rossum`;

type DevHubLinks =
  | 'docs/automation-rules-overview'
  | 'docs/implementing-custom-checks-for-automation-in-rossum'
  | 'docs/history-based-data-checks'
  | 'docs/automation-built-in-checks'
  | 'docs/using-ai-confidence-thresholds-for-automation-in-rossum'
  | 'docs/data-capture-automation';

type HelpCenterLinks =
  | '/docs/making-fields-required-validation-screen/'
  | '/docs/do-you-need-generic-or-dedicated-ai-engine/'
  | '/docs/fields-with-grey-or-green-ticks/';

export const devHub = (link: DevHubLinks) => `${DEVELOPER_HUB_LINK}/${link}`;
export const helpCenter = (link: HelpCenterLinks) =>
  `${HELP_CENTER_LINK}${link}`;

export const GITHUB_REGEX2_DOCS =
  'https://github.com/google/re2/wiki/Syntax/c6f0696bfef6b98252894469d6ef8eb70a9c9590';
export const WIKIPEDIA_MIME_TYPE_DOCS =
  'https://en.wikipedia.org/wiki/Media_type';
export const EXTERNAL_CRONTAB_VALIDATOR = 'https://crontab.guru/';

export const DEFAULT_ROW_TYPE = 'data';
export const pageSizeOptions = [10, 15, 20, 25, 50, 100] as const;

export const defaultTheme = 'dark';
export const themeTypes = [defaultTheme, 'white'] as const;
export type ThemeType = (typeof themeTypes)[number];

export const statusPageURL = 'https://status.rossum.ai';
export const contactSupportLink = 'mailto:support@rossum.ai';
export const termsAndConditionsURL = 'https://rossum.ai/terms';

export const UPLOAD_HASH = '#upload';

export const defaultWorkspaceSorting = 'alphabeticalAsc';
